// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"955622aa","237":"787807b9","460":"8f8e980b","596":"906650f7","653":"f8c7b263","702":"8893ce1a","797":"d6cc1e1e","870":"af90bb17","873":"c30b2548","901":"ef706b77","966":"0926fa9d"}[chunkId] + ".chunk.css";
};